import Driver from 'driver.js';
import DebouncedToggle from '../../../../components/debounced-toggle';

class highlightsComponent extends DebouncedToggle {
  constructor($timeout, gettextCatalog) {
    'ngInject';
    super($timeout);

    this.driver = new Driver();
    this.$timeout = $timeout;
    this.gettextCatalog = gettextCatalog;
  }

  $onInit() {}

  reset() {
    this._debounceToggle()
      .then(() => this.driver.reset())
      .catch(this._ignore);
  }

  _preventBubbling($event) {
    $event.preventDefault();
    $event.stopPropagation();
  }

  highlightWildcard($event) {
    this._preventBubbling($event);

    this.driver.highlight({
      element: '.search-input-container .fa-info-circle',
      popover: {
        title: this.gettextCatalog.getString('Wildcard Search'),
        description: this.gettextCatalog.getString('Find out more about wildcard searches'),
        position: 'below'
      }
    });
  }

  highlightHistory($event) {
    this._preventBubbling($event);

    this.driver.highlight({
      element: '.asset-search-history a',
      popover: {
        title: this.gettextCatalog.getString('Search History'),
        description: this.gettextCatalog.getString('View your recent searches'),
        position: 'below',
        showButtons: false,
        closeBtnText: 'Close'
      }
    });
  }

  highlightFavourites($event) {
    this._preventBubbling($event);

    this.driver.highlight({
      element: '.asset-search-history a',
      popover: {
        title: this.gettextCatalog.getString('Favorites'),
        description: this.gettextCatalog.getString('Select, edit and save favorites'),
        position: 'below'
      }
    });
  }

  highlightAdvanced($event) {
    this._preventBubbling($event);

    this.driver.highlight({
      element: '.advanced-filters-toggle',
      popover: {
        title: this.gettextCatalog.getString('Advanced Filters'),
        description: this.gettextCatalog.getString('Apply advanced filters to the data selection'),
        position: 'left'
      }
    });
  }

  highlightColumnSelection($event) {
    this._preventBubbling($event);

    this.driver.highlight({
      element: '.table-column-spacer .btn',
      popover: {
        title: this.gettextCatalog.getString('Column Selection'),
        description: this.gettextCatalog.getString('Select what columns you want to see in the table'),
        position: 'left'
      }
    });
  }
}

export default {
  template: require('./highlights.template.html'),
  controller: highlightsComponent,
  controllerAs: 'vm',
  bindings: {}
};
